import { useEffect, useRef, useState } from "react";
import { attachAmbientPlayback } from "@/lib/ambientVideo";
import { cn } from "@/lib/cn";

export function AmbientVideo({
  src,
  poster,
  className,
}: {
  src: string;
  poster?: string;
  className?: string;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    return attachAmbientPlayback(video, src, setPlaying);
  }, [src]);

  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 z-0 overflow-hidden opacity-40 saturate-0",
        className,
      )}
    >
      {poster ? <img src={poster} alt="" className="h-full w-full object-cover" /> : null}
      {/* Keep the poster independent of the video so a denied autoplay request
          never exposes a mobile browser's native play overlay. */}
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        disablePictureInPicture
        disableRemotePlayback
        tabIndex={-1}
        className={cn(
          "ambient-video absolute inset-0 h-full w-full object-cover motion-reduce:opacity-0",
          playing ? "opacity-100" : "opacity-0",
        )}
      />
    </div>
  );
}
